import React, { useState } from "react";
import { PiEye, PiEyeSlash } from "react-icons/pi";
import { twMerge } from "tailwind-merge";

const LoginInput = ({
  id,
  name,
  type = "text",
  label,
  value,
  placeholder,
  error,
  onChange,
  onBlur,
  showPasswordToggle,
  isPasswordVisible,
  togglePasswordVisibility,
  className,
  position,
  isRequired = true,
  isFloatingLabel = true,
  labelStyle = "",
  inputStyle = "",
  outerContainerStyle = "",
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const isFloating = Boolean(value) || isFocused;

  const getBorderClasses = () => {
    if (error) return "border-red-200";
    if (isFocused || Boolean(value)) return "border-blue-shades";
    return "border-medium-gray";
  };

  if(type === "textarea"){ // retuning textarea element
    return (
      <div className={twMerge("relative mb-7", outerContainerStyle)}>
        {label && isFloatingLabel && (
          <label
            htmlFor={id}
            className={twMerge(
              "absolute left-3 px-1 ease-in-out",
              isFloating
                ? "-top-3 z-10 bg-white font-medium"
                : "top-4 text-transparent",
              error ? "text-red-400" : "text-blue-shades"
            )}
          >
            {label}
          </label>
        )}
        {label && !isFloatingLabel && (
          <label
            htmlFor={id}
            className={`form-label block font-inter text-secondary text-level-3 font-medium leading-[24px] mb-3 ${labelStyle} `}
          >
            {label} {isRequired && <span className="text-light-red">*</span>}
          </label>
        )}
        <div className="relative">
          <textarea
            id={id}
            name={name}
            type={
              type === "password" && showPasswordToggle
                ? isPasswordVisible
                  ? "text"
                  : "password"
                : type
            }
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            onFocus={() => setIsFocused(true)}
            onBlur={(e) => {
              setIsFocused(false);
              if (onBlur) onBlur(e);
            }}
            className={twMerge(
              `w-full px-2 py-4 rounded-lg font-inter text-[15px] h-[48px] leading-[27px] text-black/40 transition-all focus:outline-none border scrollbar-none  ${className} ${getBorderClasses()}`,
              type === "password" ? "pr-10" : "",
              inputStyle,
              "placeholder:text-gray/60", // Light color for placeholder text
              "text-black/80" // Dark color for input text
            )}
          />
        </div>
        {showPasswordToggle && (
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className={`bg-white absolute text-black/40 top-1/2 right-2 transform -translate-y-1/2 w-auto px-3 ${position}`} // Adjusted right position
          >
            {isPasswordVisible ? <PiEye size={20} /> : <PiEyeSlash size={20} />}
          </button>
        )}
  
        {error && (
          <p className="mt-1 pl-0 text-xs text-red-400 absolute -bottom-[20px]">
            {error}
          </p>
        )}
      </div>
    );
  }else{ // returning non textarea element
    return (
      <div className={twMerge("relative mb-7", outerContainerStyle)}>
        {label && isFloatingLabel && (
          <label
            htmlFor={id}
            className={twMerge(
              "absolute left-3 px-1 ease-in-out",
              isFloating
                ? "-top-3 z-10 bg-white font-medium"
                : "top-4 text-transparent",
              error ? "text-red-400" : "text-blue-shades"
            )}
          >
            {label}
          </label>
        )}
        {label && !isFloatingLabel && (
          <label
            htmlFor={id}
            className={`form-label block font-inter text-secondary text-level-3 font-medium leading-[24px] mb-3 ${labelStyle} `}
          >
            {label} {isRequired && <span className="text-light-red">*</span>}
          </label>
        )}
        <div className="relative">
          <input
            id={id}
            name={name}
            type={
              type === "password" && showPasswordToggle
                ? isPasswordVisible
                  ? "text"
                  : "password"
                : type
            }
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            onFocus={() => setIsFocused(true)}
            onBlur={(e) => {
              setIsFocused(false);
              if (onBlur) onBlur(e);
            }}
            className={twMerge(
              `w-full px-2 py-4 rounded-lg font-inter text-[15px] h-[48px] leading-[27px] text-black/40 transition-all focus:outline-none border ${className} ${getBorderClasses()}`,
              type === "password" ? "pr-10" : "",
              inputStyle,
              "placeholder:text-gray/60", // Light color for placeholder text
              "text-black/80" // Dark color for input text
            )}
          />
        </div>
        {showPasswordToggle && (
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className={`bg-white absolute text-black/40 top-1/2 right-2 transform -translate-y-1/2 w-auto px-3 ${position}`} // Adjusted right position
          >
            {isPasswordVisible ? <PiEye size={20} /> : <PiEyeSlash size={20} />}
          </button>
        )}
  
        {error && (
          <p className="mt-1 pl-0 text-xs text-red-400 absolute -bottom-[20px]">
            {error}
          </p>
        )}
      </div>
    );
  }
};

export default LoginInput;

{/* <textarea
placeholder="Leave feedback about the delivered work"
value={feedback}
onChange={(e) => {setFeedback(e.target.value)}}
className="w-full text-inter text-gray text-level-4 rounded-[5px] border border-medium-gray p-3 focus:outline-none mt-[32px] min-h-[166px]"
rows="4"
></textarea> */}
